/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PathologyStrictHttpResponse } from '../../pathology-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormStatus } from '../../models/form-status';

export interface PathologyIdGetStatusGet$Params {
  id: string;
}

export function pathologyIdGetStatusGet(http: HttpClient, rootUrl: string, params: PathologyIdGetStatusGet$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<FormStatus | null>> {
  const rb = new RequestBuilder(rootUrl, pathologyIdGetStatusGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PathologyStrictHttpResponse<FormStatus | null>;
    })
  );
}

pathologyIdGetStatusGet.PATH = '/Pathology/{id}/GetStatus';
